import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import SignInPage from "./components/SignInPage";
import HomePage from "./components/HomePage";
import Layout from "./components/Layout";
import "./index.css";
import JobForm from "./components/JobTypeForm";
import { Details, UserProvider, ThemeProvider } from "ogcommon";
import Admin from "./components/admin";

function App() {
  return (
    <UserProvider>
      <ThemeProvider>
        <Routes>
          <Route path="/" element={<SignInPage />} />
          <Route
            path="/home"
            element={
              <Layout>
                <HomePage />
              </Layout>
            }
          />
          {/* Remove or comment out the routes and imports for components that don't exist yet:
              <Route
                path="/create-field-ticket/:highestTicketNumber"
                element={
                  <Layout>
                    <CreateFieldTicket />
                  </Layout>
                }
              />
          */}

          {/* Also remove the routes for FieldTicketEntry, Summary, and TicketGrid if files aren’t present */}

          <Route
            path="/job-form"
            element={
              <Layout>
                <JobForm />
              </Layout>
            }
          />
          <Route
            path="/profile-details"
            element={
              <Layout>
                <Details />
              </Layout>
            }
          />
          <Route
            path="/admin-panel"
            element={
              <Layout>
                <Admin />
              </Layout>
            }
          />
        </Routes>
      </ThemeProvider>
    </UserProvider>
  );
}

export default App;
